import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private toastMessageSource = new Subject<{ message: string, type?: string }>();
  toastMessage$ = this.toastMessageSource.asObservable();

  showToast(message: string, type: string = 'danger') {
    this.toastMessageSource.next({ message, type });
  }
}
